<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text animate-target" v-animate-in>A lower mean UACR with finerenone versus placebo was maintained throughout the study</div>
    <div ref="target" class="show_animation animate-target" v-animate-in>
      <img src="../../assets/images/p3-9/chart.svg" />
      <img src="../../assets/images/p3-9/line.svg" />
      <img src="../../assets/images/p3-9/num.svg" />
    </div>
    <GoNext class="animate-target" v-animate-in href="/section3/3-10">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-9",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"Data in parentheses are mean changes from baseline. *Full analysis set. Mixed model with factors treatment group, region, eGFR category at screening, type of albuminuria at screening, CV disease history, time, treatment*time, study, study*treatment, log transformed baseline value nested within type of albuminuria at screening and log transformed baseline value*time as covariate. Separate unstructured covariance patterns are estimated for each treatment group; <sup>#</sup>data are LS mean ± SD<br/>"
      +"LS, least squares; gSD, geometric standard deviation; SD, standard deviation<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. Eur Heart J</i> 2021;doi:10.1093/eurheartj/ehab777/6433104.",
      title:"In FIDELITY, finerenone reduced UACR by 32% between baseline and month 4 versus placebo<sup>*1</sup>"
    }
  },
  mounted() {
    this.initClassObserver(); // 组件挂载后初始化监听
  },
  beforeDestroy() {
    this.destroyObserver(); // 组件卸载前销毁监听
  },
  methods: {

    initClassObserver() {
      const targetEl = this.$refs.target;
      if (!targetEl) return;

      this.observer = new MutationObserver((mutations) => {
        console.log(mutations);
        const mutation = mutations[0];
        if (mutation.attributeName === 'class') {
          targetEl.children[1].classList.add('extend2')
          targetEl.children[2].classList.add('fadeIn')
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      };

      this.observer.observe(targetEl, config);
    },

    // 销毁观察者（避免内存泄漏）
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect(); // 断开监听
        this.observer = null; // 清空实例
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-text {
  font-size: 24px;
  color: #10384F;
  font-weight: bold;
  margin-top: 40px;
}
.show_animation {
  position:relative;
  width: 100%;
  margin-top: 30px;
}
.show_animation img {
  width: 100%;
}
.show_animation img:nth-child(2) {
  position:absolute;
  height: 100%;
  bottom:0px;
  left:0px;
  width:0%;
  object-fit: cover;
  object-position: left;
}
.show_animation img:nth-child(3) {
  position:absolute;
  width: 100%;
  bottom:0px;
  left:0px;
  object-fit: cover;
  object-position: bottom;
  opacity: 0;
}
</style>
